import { render, staticRenderFns } from "./DomesticMigrationTool.vue?vue&type=template&id=27474223&scoped=true"
import script from "./DomesticMigrationTool.vue?vue&type=script&lang=js"
export * from "./DomesticMigrationTool.vue?vue&type=script&lang=js"
import style0 from "./DomesticMigrationTool.vue?vue&type=style&index=0&id=27474223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27474223",
  null
  
)

export default component.exports